<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-gradient-warning opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-lg-7 col-md-10">
            <p class="text-white mt-3 mb-5">
              Aqui você poderá abrir e controlar o pitch day. Para sua abertura
              é necessário preencher as informações inicias abaixo e selecionar
              as startups participantes. Após a criação, é possível gerenciar o
              status do pitch day.
            </p>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--8">
      <div class="row mb-4">
        <div class="col-12">
          <call-card v-if="call" :call="call" />
        </div>
      </div>
      <div class="row">
        <div class="col-xl-8">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-12">
                  <h3
                    class="mb-0 d-flex align-items-center justify-content-between"
                  >
                    <div>Pitch Day <span class="text-warning">STARS</span></div>
                    <base-button
                      v-if="pitchDay"
                      type="default"
                      class="float-right"
                      @click="
                        $router.push(
                          `/admin/pitch-days/${pitchDay.id}/respostas`
                        )
                      "
                      ><i class="fas fa-eye mr-2"></i>Visualizar
                      respostas</base-button
                    >
                  </h3>
                </div>
              </div>
            </div>
            <template>
              <form @submit.prevent>
                <h6 class="heading-small text-muted mb-4">Detalhes</h6>
                <div class="pl-lg-2">
                  <div class="col">
                    <i class="fas fa-rocket mr-2 text-warning"></i>
                    <span>Startups inscritas na chamada: </span>
                    <badge type="info" class="p-2 bg-white"
                      ><span
                        v-if="count.subscriptions"
                        class="font-weight-600"
                        >{{ count.subscriptions }}</span
                      ><span v-else class="text-warning"
                        >nenhuma inscrição até o momento</span
                      ></badge
                    >
                    <base-button
                      type="secondary"
                      @click="
                        $router.push(
                          `/admin/chamadas/${$route.params.id}/inscricoes`
                        )
                      "
                      size="sm"
                      class="float-right"
                      :custom="true"
                      >Gerenciar inscrições</base-button
                    >
                  </div>
                  <div class="col mt-3">
                    <i class="fas fa fa-user-tie mr-2 text-primary"></i>
                    <span>Investidores vinculados ao fundo: </span>
                    <badge type="info" class="p-2 bg-white"
                      ><span v-if="count.investors" class="font-weight-600">{{
                        count.investors
                      }}</span
                      ><span class="text-warning" v-else
                        >não há investidores cadastrados</span
                      ></badge
                    >
                    <base-button
                      type="secondary"
                      @click="
                        $router.push(
                          `/admin/fundos/${call.fund_id}/investidores`
                        )
                      "
                      size="sm"
                      class="float-right"
                      :custom="true"
                      >Gerenciar investidores</base-button
                    >
                  </div>
                </div>
                <hr class="my-4" />
                <div v-if="pitchDay">
                  <h6 class="heading-small text-muted">Informações básicas</h6>
                  <div class="pl-lg-4">
                    <div class="row">
                      <div class="col-lg-6">
                        <label class="form-control-label"
                          >Data do pitch day</label
                        >
                        <p>{{ formatDate(pitchDay.date) }}</p>
                      </div>
                      <div class="col-lg-6">
                        <label class="form-control-label">
                          Status do pitch day
                        </label>
                        <p>
                          <i
                            class="fas fa-info-circle mr-1"
                            :title="currentStatus.description"
                          ></i>
                          {{ currentStatus.value }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <hr class="mt-2 mb-4" />
                  <h6 class="heading-small text-muted mb-4">
                    Startups no pitch day
                  </h6>
                  <div class="pl-lg-4 pl-md-0 row">
                    <div
                      class="col-lg-4 col-md-4 mb-4 d-flex align-items-stretch"
                      v-for="(ps, index) in pitchDay.subscriptions"
                      :key="'startup_' + index"
                    >
                      <div class="card shadow text-center flex-grow-1">
                        <div class="card-profile-image">
                          <img
                            :src="
                              getStartupLogoPath(ps.subscription.startup.logo)
                            "
                            class="card-image my-3"
                            alt="..."
                          />
                        </div>
                        <div class="card-body mt-7 pt-0 pb-2">
                          <h2 class="card-title text-orange mb-1">
                            {{ ps.subscription.startup.name }}
                          </h2>
                          <div class="h5 font-weight-300">
                            <i class="ni ni-pin-3 mr-2"></i
                            >{{ ps.subscription.startup.city || "..." }},
                            {{ ps.subscription.startup.state || "..." }}
                          </div>
                        </div>
                        <div class="card-footer p-0 text-center">
                          <base-button
                            type="link"
                            :iconOnly="true"
                            icon="fas fa-eye"
                            @click="
                              $router.push(
                                `/admin/chamadas/${call.id}/inscricoes/${ps.subscription.id}`
                              )
                            "
                          ></base-button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr class="my-4" />
                  <h6 class="heading-small text-muted my-4">
                    Perguntas para avaliação
                  </h6>
                  <div class="pl-lg-4 pl-md-0">
                    <div
                      class="row mb-2"
                      v-for="(question, index) in pitchDay.questions"
                      :key="index"
                    >
                      <div class="col-12 mb-2">
                        <span class="form-control-label">
                          Pergunta {{ index + 1 }}
                        </span>
                      </div>
                      <p class="pl-4">
                        <i class="fas fa-arrow-right"></i> {{ question.title }}
                        <span class="text-muted"
                          >({{ question.description }})</span
                        >
                      </p>
                    </div>
                  </div>
                  <div class="text-center mt-1">
                    <base-alert type="danger" v-if="error" class="mb-4">{{
                      error
                    }}</base-alert>
                    <base-button type="white" @click="handleDeletePitchDay"
                      ><i class="fas fa-trash mr-1 text-danger"></i> Excluir
                      Pitch Day</base-button
                    >
                    <base-button
                      type="white"
                      @click="handleChangePitchDayStatus"
                      ><i class="fas fa-marker mr-1 text-info"></i> Alterar
                      status do pitch day</base-button
                    >
                  </div>
                </div>
                <div v-else-if="count.subscriptions && count.investors">
                  <h6 class="heading-small text-muted mb-4">
                    Informações básicas
                  </h6>
                  <div class="pl-lg-4">
                    <div class="row">
                      <div class="col-lg-6">
                        <label class="form-control-label"
                          >Data do pitch day</label
                        >
                        <base-input
                          type="date"
                          addon-left-icon="ni ni-calendar-grid-58"
                          placeholder="Data"
                          input-classes="form-control"
                          v-model="model.date"
                        />
                      </div>
                      <div class="col-lg-6">
                        <label class="form-control-label">
                          Status do pitch day
                        </label>
                        <div>
                          <base-input addon-left-icon="fas fa-cogs">
                            <select class="form-control" v-model="model.status">
                              <option selected disabled value="">
                                Selecione o status do pitch day
                              </option>
                              <option
                                v-for="status in pitchDayStatus"
                                :key="'new_status_' + status.key"
                                :value="status.key"
                              >
                                {{ status.value }}
                              </option>
                            </select>
                          </base-input>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr class="my-4" />
                  <h6 class="heading-small text-muted mb-4">
                    Perguntas para avaliação
                  </h6>
                  <div class="pl-lg-4 pl-md-0">
                    <div
                      class="row mb-4"
                      v-for="(question, index) in questions"
                      :key="index"
                    >
                      <div class="col-12">
                        <div
                          class="mb-2 d-flex align-items-center justify-content-between"
                        >
                          <span class="form-control-label"
                            >Pergunta {{ index + 1 }}</span
                          >
                          <base-button
                            type="link"
                            class="text-danger"
                            :iconOnly="true"
                            icon="fas fa-times"
                            @click="handleRemoveQuestion(index)"
                          />
                        </div>
                      </div>
                      <div class="col-lg-6">
                        <textarea
                          rows="2"
                          class="form-control form-control"
                          placeholder="Título da pergunta"
                          v-model="question.title"
                        ></textarea>
                      </div>
                      <div class="col-lg-6 mt-2 mt-lg-0">
                        <textarea
                          rows="2"
                          class="form-control form-control"
                          placeholder="Digite aqui uma breve descrição para instruir o investidor a responder a pergunta"
                          v-model="question.description"
                        >
                        </textarea>
                      </div>
                    </div>
                    <div class="mt-3 text-right">
                      <base-button
                        type="link"
                        @click="handleAddDefaultQuestions"
                        size="sm"
                        >Adicionar perguntas padrão</base-button
                      >
                      <base-button
                        @click="handleAddNewQuestion"
                        size="sm"
                        :custom="true"
                        >Adicionar nova pergunta</base-button
                      >
                    </div>
                  </div>
                  <hr class="my-4" />
                  <h6 class="heading-small text-muted mb-4">
                    Startups participantes do pitch day
                  </h6>
                  <div class="pl-lg-4 pl-md-0">
                    <div class="row">
                      <div class="col-sm-12 col-lg-8">
                        <div>
                          <v-select
                            class="startup_select"
                            placeholder="Busque por uma startup (nome ou email)"
                            :getOptionLabel="(opt) => opt.startup.name"
                            :options="subscriptions"
                            :filter-by="filterByNameOrEmail"
                            v-model="selectedSubscription"
                            @input="handleSelectSubscription"
                          >
                            <template v-slot:option="option">
                              <i class="fa fa-rocket mr-2"></i>
                              {{ option.startup.name }}
                              <span class="float-right text-xs"
                                >Email: {{ option.startup.user.email }}</span
                              >
                            </template>
                            <span slot="no-options">Não há startups</span>
                          </v-select>
                        </div>
                      </div>
                      <div
                        class="col-sm-6 offset-sm-3 offset-lg-0 col-lg-4 my-3 my-lg-0 text-center"
                      >
                        <base-button
                          :custom="true"
                          size="lg"
                          @click="handleAddSubscription"
                          >Adicionar ao pitch day</base-button
                        >
                      </div>
                      <div class="col-12 text-right mt-2 text-muted">
                        Startups selecionadas até o momento:
                        <b>{{ selectedSubscriptions.length }}</b>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-12">
                      <div v-if="!selectedSubscriptions.length">
                        <div class="row">
                          <div class="col-12 text-center">
                            <badge class="mt-3 bg-white" type="warning">
                              Nenhuma startup cadastrada no pitch day até o
                              momento. Selecione-as a partir da caixa de busca.
                            </badge>
                          </div>
                        </div>
                      </div>
                      <div v-else class="card-deck">
                        <div
                          class="col-md-6 col-xs-12 mt-5"
                          v-for="subscription in selectedSubscriptions"
                          :key="
                            'selected_startups_' + subscription.startup.user_id
                          "
                        >
                          <div class="card text-center">
                            <div class="card-profile-image">
                              <img
                                :src="subscription.startup.logo.url"
                                class="card-image my-4"
                                alt="..."
                              />
                            </div>
                            <div class="card-body mt-8 pt-0 pb-1">
                              <h2 class="card-title text-orange mb-1">
                                {{ subscription.startup.name }}
                              </h2>
                              <div>
                                <div class="h5 font-weight-300 mb-1">
                                  <i class="ni ni-pin-3 mr-2"></i
                                  >{{ subscription.startup.city || "..." }},
                                  {{ subscription.startup.state || "..." }}
                                </div>
                                <div>
                                  <div class="h5 font-weight-300 mb-1">
                                    <i class="fas fa-envelope mr-2"></i
                                    >{{ subscription.startup.user.email }}
                                  </div>
                                </div>
                                <div class="h5 mt-2">
                                  <badge type="info">
                                    {{ subscription.startup.sector }}
                                  </badge>
                                </div>
                              </div>
                            </div>
                            <div class="card-footer text-center">
                              <base-button
                                type="white"
                                icon="fas fa-trash text-red"
                                @click="
                                  handleRemoveSubscription(subscription.id)
                                "
                              ></base-button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-12 mt-4 text-center">
                      <base-alert type="danger" v-if="error" class="mb-4">{{
                        error
                      }}</base-alert>
                      <base-button
                        type="primary"
                        :custom="true"
                        size="lg"
                        @click="handleOpenPitchDay"
                        :disabled="!isValidModel"
                      >
                        Cadastrar pitch day
                      </base-button>
                    </div>
                  </div>
                </div>
                <div v-else class="col-12 text-center">
                  <base-alert class="mt-2" type="danger">
                    Para gerencar o pitch day é preciso que a chamada esteja em
                    um fundo com investidores cadastrados e existam startups
                    inscritas no processo seletivo.
                  </base-alert>
                </div>
              </form>
            </template>
          </card>
        </div>
        <div
          class="col-xl-4 order-xl-1 mb-xl-0 mb-5 mt-5 mt-lg-0"
          v-if="selectedSubscriptionInfo"
        >
          <div class="card text-center">
            <div class="card-profile-image">
              <img
                :src="selectedSubscriptionInfo.startup.logo.url"
                class="card-image my-4"
                alt="..."
              />
            </div>
            <div class="card-body mt-8 pt-0">
              <h2 class="card-title text-orange mb-1">
                {{ selectedSubscriptionInfo.startup.name }}
              </h2>
              <div>
                <div class="h5 font-weight-300 mb-1">
                  <i class="ni ni-pin-3 mr-2"></i
                  >{{ selectedSubscriptionInfo.startup.city || "..." }},
                  {{ selectedSubscriptionInfo.startup.state || "..." }}
                </div>
                <div>
                  <div class="h5 font-weight-300 mb-1">
                    <i class="fas fa-envelope mr-2"></i
                    >{{ selectedSubscriptionInfo.startup.user.email }}
                  </div>
                </div>
                <div class="h5 mt-2">
                  <badge type="info">
                    {{ selectedSubscriptionInfo.startup.sector }}
                  </badge>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal
      :show.sync="modals.modalOpen"
      gradient="default"
      modal-classes="modal-warning modal-dialog-centered"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Atenção!
      </h6>

      <div class="py-3 text-center">
        <i class="fa fa-marker fa-3x"></i>
        <h4 class="heading mt-4">
          Você realmente deseja criar o Pitch Day da chamada
          <span class="text-warning">{{ call.name }}</span
          >?
        </h4>
        <p class="mt-3 mb-0">
          <i class="fas fa-info-circle mr-1"></i> Ao abrir o pitch day para
          avaliação, os
          <b class="text-warning font-weight-600"
            >{{ count.investors }} investidores</b
          >
          cadastrados no fundo dessa chamada poderão avaliar as
          <b class="text-warning font-weight-600"
            >{{ count.subscriptions }} startups</b
          >
          inscritas.
        </p>
      </div>

      <template slot="footer">
        <base-button
          type="link"
          text-color="white"
          class="ml-auto"
          @click="modals.modalOpen = false"
        >
          Voltar
        </base-button>
        <base-button type="white" @click="handleSubmitOpenPitchDay">
          Confirmar
        </base-button>
      </template>
    </modal>
    <modal
      :show.sync="modals.modalRemove"
      gradient="dark"
      modal-classes="modal-danger modal-dialog-centered"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Atenção!
      </h6>
      <div class="vld-parent" ref="modal_confirmation_delete">
        <div class="py-3 text-center">
          <i class="fa fa-marker fa-3x"></i>
          <h4 class="heading mt-4">
            Você realmente deseja excluir o Pitch Day da chamada
            <span class="text-warning">{{ call.name }}</span
            >?
          </h4>
          <p class="mt-3 mb-0">
            Se existirem, todas as avaliações dos investidores das startups
            inscritas nessa chamada serão perdidas. Talvez você deseje apenas
            encerrar o pitch day?
          </p>
          <p class="mt-3">
            Por favor, digite
            <span class="text-warning font-weight-bold">{{ call.name }}</span>
            para prosseguir
          </p>
          <base-input
            placeholder="Digite aqui"
            input-classes="form-control"
            addon-left-icon="fas fa-trash text-warning"
            v-model="modals.inputConfirmation"
          />
        </div>
      </div>
      <template slot="footer">
        <base-button
          type="link"
          text-color="white"
          class="ml-auto"
          @click="modals.modalRemove = false"
        >
          Voltar
        </base-button>
        <base-button
          type="white text-danger"
          @click="handleSubmitRemovePitchDay"
          :disabled="!inputConfirmationTextIsValid()"
        >
          Confirmar exclusão
        </base-button>
      </template>
    </modal>
    <modal
      :show.sync="modals.modalChange"
      gradient="default"
      modal-classes="modal-warning modal-dialog-centered"
      v-if="modals.newStatus"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Atenção!
      </h6>

      <div class="py-3 text-center">
        <i class="fa fa-globe fa-3x"></i>
        <h4 class="heading mt-4">
          Pitch Day da chamada
          <span class="text-warning">{{ this.call.name }}</span>
        </h4>
        <p class="mt-3 mb-0">
          Atualmente o Pitch Day está com status
          <span class="text-warning">{{ currentStatus.value }}</span
          >. Para alterá-lo, selecione um novo status:
        </p>
        <div class="mt-2">
          <base-input addon-left-icon="fas fa-cogs">
            <select class="form-control" v-model="modals.newStatus">
              <option selected disabled value="">
                Selecione o status do pitch day
              </option>
              <option
                v-for="status in pitchDayStatus"
                :key="'updt_status_' + status.key"
                :value="status.key"
              >
                {{ status.value }}
              </option>
            </select>
          </base-input>
        </div>
        <div class="text-muted text-sm">
          <i class="fas fa-info-circle mr-1"></i>
          {{
            pitchDayStatus.find((status) => status.key === modals.newStatus)
              .description
          }}
        </div>
      </div>

      <template slot="footer">
        <base-button
          type="link"
          text-color="white"
          class="ml-auto"
          @click="modals.modalChange = false"
        >
          Voltar
        </base-button>
        <base-button
          type="white"
          @click="handleSubmitChangePitchDayStatus"
          :disabled="currentStatus.key == modals.newStatus"
        >
          Alterar status
        </base-button>
      </template>
    </modal>
  </div>
</template>
<script>
import api from "@/services/api.js";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import CallCard from "@/components/CallCard";

export default {
  name: "chamada",
  components: {
    "v-select": vSelect,
    CallCard,
  },
  data() {
    return {
      model: {
        status: "",
        date: "",
      },
      pitchDay: "",
      count: {
        subscriptions: 0,
        investors: 0,
      },
      questions: [
        {
          title: "",
          description: "",
        },
      ],
      defaultQuestions: [
        {
          title: "Valor ao cliente",
          description:
            "A solução entrega valor significativo ao cliente. Indica o motivo pelo qual o cliente utiliza a solução.",
        },
        {
          title: "Maturidade da solução",
          description:
            "Indica o quanto a solução está pronta para ser oferecida ao mercado, com processo de vendas estruturado e escalável.",
        },
        {
          title: "Vantagem competitiva",
          description:
            "A solução é substancialmente melhor que as outras opções disponíveis no mercado, difícil de ser substituída e difícil de ser imitada.",
        },
        {
          title: "Viabilidade técnica e de produção",
          description:
            "A solução foi desenvolvida pela Startup que busca por implementar melhorias constantes na solução oferecida. Há disponibilidade de recursos para produzir a solução oferecida.",
        },
        {
          title: "Atratividade de Mercado e de investimentos",
          description:
            "O mercado tem tamanho significativo, não está saturado de outras soluções, tem comportamento cíclico ou perene. E é atrativo para novos investidores.",
        },
      ],
      call: "",
      subscriptions: [],
      filterByNameOrEmail: (option, label, search) => {
        const temp = search.toLowerCase();
        return (
          option.startup.name.toLowerCase().indexOf(temp) > -1 ||
          option.startup.user.email.toLowerCase().indexOf(temp) > -1
        );
      },
      selectedSubscription: "",
      selectedSubscriptionInfo: "",
      selectedSubscriptions: [],
      error: "",
      pitchDayStatus: [
        {
          key: "open",
          value: "Aberto",
          description:
            "Um pitch day aberto fica visível para os investidores, que podem avaliar as startups selecionadas.",
        },
        {
          key: "closed",
          value: "Encerrado",
          description:
            "Um pitch day encerrado pode ser visualizado no histórico, porém o investidor não pode realizar novas avaliações.",
        },
        {
          key: "hidden",
          value: "Invisível",
          description:
            "Um pitch day invisível fica oculto para todos os investidores, não aparecendo nem mesmo em seu histórico.",
        },
      ],
      currentStatus: {
        key: "",
        value: "",
        description: "",
      },
      modals: {
        modalOpen: false,
        modalChange: false,
        newStatus: "",
        modalRemove: false,
        inputCofirmation: "",
      },
    };
  },
  async mounted() {
    const loader = this.$loading.show({
      width: 200,
      height: 200,
    });
    await this.loadCall();
    await this.loadPitchDay();
    loader.hide();
  },
  methods: {
    async loadCall() {
      try {
        const {
          data: { call, subscriptions, subscriptions_count, investors_count },
        } = await api.get(
          `/adm/startup-calls/${this.$route.params.id}?subscriptions=true&count=true`
        );
        call.region_limited = call.region_limited ? true : false;
        if (call.sectors)
          call.sectors = call.sectors.split(";").filter((s) => s);
        this.call = call;
        this.subscriptions = subscriptions;
        const defaultLogoPath = "/img/pages/default_logo.png";
        this.subscriptions.forEach((subscription) => {
          if (!subscription.startup.logo)
            subscription.startup.logo = { url: defaultLogoPath };
        });
        this.count.subscriptions = subscriptions_count;
        this.count.investors = investors_count;
      } catch (e) {
        this.$toasted.error(
          "Ocorreu um erro ao recuperar as informações da chamada"
        );
        this.$router.push(`/admin/chamadas`);
      }
    },
    async loadPitchDay() {
      try {
        const { data: pitchDay } = await api.get(
          `/adm/startup-calls/${this.$route.params.id}/pitch-days`
        );
        if (pitchDay) {
          this.pitchDay = pitchDay;
          this.currentStatus = this.pitchDayStatus.find(
            (status) => status.key === pitchDay.status
          );
        }
      } catch (e) {
        this.$toasted.error(
          "Ocorreu um erro ao recuperar as informações do pitch day"
        );
        this.$router.push(`/admin/chamadas`);
      }
    },
    async handleSubmitOpenPitchDay() {
      this.error = "";
      const validQuestions = [];
      this.questions.forEach((question) => {
        if (question.title && question.description)
          validQuestions.push(question);
      });
      const subscriptionsId = this.selectedSubscriptions.map(function (
        subscription
      ) {
        return subscription.id;
      });
      const loader = this.$loading.show({
        width: 200,
        height: 200,
      });
      try {
        await api.post(`/adm/pitch-days`, {
          ...this.model,
          startup_call_id: this.call.id,
          questions: validQuestions,
          subscriptions: subscriptionsId,
        });
        this.$toasted.show("Pitch day criado com sucesso");
        this.$router.push("/admin/chamadas");
      } catch (e) {
        this.error = "Ocorreu um erro ao criar o pitch day. Tente novamente.";
        this.$toasted.error("Ocorreu um erro ao salvar as informações");
        this.modals.modalOpen = false;
      } finally {
        loader.hide();
      }
    },
    async handleSubmitRemovePitchDay() {
      const loader = this.$loading.show({
        container: this.$refs.modal_confirmation_delete,
        width: 160,
        height: 160,
        opacity: 0,
      });
      try {
        await api.delete(`/adm/pitch-days/${this.pitchDay.id}`);
        this.$toasted.show("Pitch day removido com sucesso");
        this.$router.push("/admin/chamadas");
      } catch (e) {
        this.error = "Ocorreu um erro ao remover o pitch day.";
        this.$toasted.error(this.error);
        this.modals.modalRemove = false;
      } finally {
        loader.hide();
      }
    },
    async handleSubmitChangePitchDayStatus() {
      const loader = this.$loading.show({
        width: 200,
        height: 200,
      });
      try {
        await api.put(`/adm/pitch-days/${this.pitchDay.id}`, {
          status: this.modals.newStatus,
        });
        this.$toasted.show("Status do pitch day atualizado com sucesso");
        this.$router.push("/admin/chamadas");
      } catch (e) {
        this.error = "Ocorreu um erro ao alterar o status do pitch day.";
        this.$toasted.error("Ocorreu um erro ao salvar as informações");
        this.modals.modalChange = false;
      } finally {
        loader.hide();
      }
    },
    handleSelectSubscription() {
      this.selectedSubscriptionInfo = this.selectedSubscription;
    },
    handleAddSubscription() {
      if (!this.selectedSubscription) return;
      this.swipeBetweenLists(
        this.subscriptions,
        this.selectedSubscriptions,
        this.selectedSubscription.id
      );
      this.selectedSubscription = "";
      this.selectedSubscriptionInfo = false;
    },
    handleRemoveSubscription(id) {
      this.swipeBetweenLists(
        this.selectedSubscriptions,
        this.subscriptions,
        id
      );
    },
    swipeBetweenLists(source, target, subscriptionId) {
      const index = source
        .map((subscription) => {
          return subscription.id;
        })
        .indexOf(subscriptionId);
      if (index !== -1) target.push(...source.splice(index, 1));
    },
    handleAddNewQuestion() {
      this.questions.push({ title: "", description: "" });
    },
    handleAddDefaultQuestions() {
      if (
        this.questions[0] &&
        !this.questions[0].title &&
        !this.questions[0].description
      )
        this.questions.shift();
      this.questions.push.apply(this.questions, this.defaultQuestions);
    },
    handleRemoveQuestion(index) {
      this.questions.splice(index, 1);
    },
    handleOpenPitchDay() {
      this.modals.modalOpen = true;
    },
    handleDeletePitchDay() {
      this.modals.inputCofirmation = "";
      this.modals.modalRemove = true;
    },
    handleChangePitchDayStatus() {
      this.modals.newStatus = this.currentStatus.key;
      this.modals.modalChange = true;
    },
    inputConfirmationTextIsValid() {
      return this.modals.inputConfirmation === this.call.name;
    },
    getStartupLogoPath(logo) {
      const defaultLogoPath = "/img/pages/default_logo.png";
      if (!logo) return defaultLogoPath;
      return logo.url;
    },
  },
  computed: {
    isValidModel() {
      const data = this.model;
      if (this.selectedSubscriptions.length <= 0) return false;
      for (const key in data) {
        if (data[key] === "") return false;
      }
      return true;
    },
  },
};
</script>
<style scoped>
.card-image {
  width: 100px;
  height: 100px;
  border-radius: 10%;
  margin: auto;
}
</style>
<style>
.startup_select.v-select {
  background-color: #fff;
  background-clip: padding-box;
  border: 0.3px solid #cad1d7;
  border-radius: 0.375rem;
}
.startup_select.v-select .vs__dropdown-toggle {
  padding: 8px;
}
.startup_select.v-select
  .vs__dropdown-toggle
  .vs__selected-options
  .vs__search {
  color: #8898aa;
  line-height: 1.5;
  font-weight: 400;
}
</style>
